import { Typography } from 'antd'
import { CIMSTabs } from 'components/CIMSTabs'
import SharePoint from './components/SharePoint'
import Settings from './components/Settings'
import IFITrackerSettings from './components/IFITracker'

const ProjectSettings: React.FC = () => {
  const Tab = {
    Settings: 'Settings',
    SharePoint: 'SharePoint',
    IFITracker: 'IFI Tracker',
  } as const
  return (
    <CIMSTabs
      prefix={
        <Typography.Text>
          Project settings affect certain operations for every user.
        </Typography.Text>
      }
      initialTab={Tab.Settings}
      tabs={[
        {
          component: <Settings />,
          key: Tab.Settings,
          label: Tab.Settings,
        },
        {
          component: <SharePoint />,
          key: Tab.SharePoint,
          label: Tab.SharePoint,
        },
        {
          component: <IFITrackerSettings />,
          key: Tab.IFITracker,
          label: Tab.IFITracker,
        },
      ]}
    />
  )
}

export default ProjectSettings
